import { Language } from '../types';
import { CityData } from './citiesData';

interface CityRawConfig {
  slug: string;
  name: string;
  postalCode: string;
  region: 'Brussels' | 'Flanders' | 'Wallonia';
  responseTime: string;
  landmarks: {
    fr: string[];
    nl: string[];
    en: string[];
  };
  clientAuthor: string;
  clientNeighborhood: string;
  clientService: { fr: string; nl: string; en: string };
  clientReview: { fr: string; nl: string; en: string };
}

const RAW_COMMUNES: CityRawConfig[] = [
  // --- BRUXELLES ---
  {
    slug: 'schaerbeek',
    name: 'Schaerbeek (1030)',
    postalCode: '1030',
    region: 'Brussels',
    responseTime: '20 - 30 min',
    landmarks: {
      fr: ['Place Colignon', 'Parc Josaphat', 'Meiser', 'Dailly', 'Gare de Schaerbeek'],
      nl: ['Colignonplein', 'Josaphatpark', 'Meiser', 'Dailly', 'Station Schaarbeek'],
      en: ['Colignon Square', 'Josaphat Park', 'Meiser', 'Dailly', 'Schaerbeek Station']
    },
    clientAuthor: 'Youssef B.',
    clientNeighborhood: 'Josaphat (1030)',
    clientService: { fr: 'Débouchage Urgent', nl: 'Spoedontstopping', en: 'Emergency Unblocking' },
    clientReview: {
      fr: 'Canalisation générale bouchée dans notre maison de maître. Équipe arrivée en 25 minutes avec le camion haute pression. Travail propre et efficace.',
      nl: 'Hoofdafvoer verstopt in herenhuis. Binnen 25 minuten ter plaatse met hogedrukwagen. Heel vlot opgelost.',
      en: 'Main sewer line clogged in our townhouse. Arrived in 25 minutes with hydro-jetting van. Clean and fast job.'
    }
  },
  {
    slug: 'saint-gilles',
    name: 'Saint-Gilles (1060)',
    postalCode: '1060',
    region: 'Brussels',
    responseTime: '20 - 25 min',
    landmarks: {
      fr: ['Parvis de Saint-Gilles', 'Barrière', 'Prison', 'Porte de Hal', 'Hôtel de Ville'],
      nl: ['Voorplein Sint-Gillis', 'Bareel', 'Gevangenis', 'Hallepoort', 'Gemeentehuis'],
      en: ['Parvis of Saint-Gilles', 'Barrier', 'Halle Gate', 'Town Hall', 'Ducpétiaux']
    },
    clientAuthor: 'Claire M.',
    clientNeighborhood: 'Parvis (1060)',
    clientService: { fr: 'Dépannage Chaudière Gaz', nl: 'Herstelling Gasketel', en: 'Gas Boiler Repair' },
    clientReview: {
      fr: 'Chaudière tombée en panne de veilleuse par temps de grand froid. Dépannée en 30 minutes avec pièce neuve d\'origine. Chauffagiste très pro.',
      nl: 'Ketel uitgevallen tijdens vriesweer. Binnen een half uur hersteld met origineel wisselstuk. Toptechnieker.',
      en: 'Boiler pilot light failure during sub-zero temperatures. Repaired in 30 minutes with genuine replacement part.'
    }
  },
  {
    slug: 'molenbeek',
    name: 'Molenbeek-Saint-Jean (1080)',
    postalCode: '1080',
    region: 'Brussels',
    responseTime: '20 - 30 min',
    landmarks: {
      fr: ['Mettewie', 'Tour & Taxis', 'Parc Marie-José', 'Karreveld', 'Place Communale'],
      nl: ['Mettewielaan', 'Tour & Taxis', 'Marie-Josépark', 'Karreveld', 'Gemeenteplein'],
      en: ['Mettewie Ave', 'Tour & Taxis', 'Marie-Jose Park', 'Karreveld', 'Town Square']
    },
    clientAuthor: 'Ibrahim K.',
    clientNeighborhood: 'Mettewie (1080)',
    clientService: { fr: 'Recherche de Fuite d\'Eau', nl: 'Lekdetectie Zonder Breekwerk', en: 'Non-Destructive Leak Detection' },
    clientReview: {
      fr: 'Infiltration d\'eau chez le voisin du dessous. Détection par caméra thermique sans rien casser, puis réparation immédiate du tuyau cuivre.',
      nl: 'Waterinfiltratie bij onderbuur. Lek opgespoord met thermische camera zonder breekwerk en koperleiding direct hersteld.',
      en: 'Water leak into apartment below. Located via thermal imaging without destruction and pipe repaired immediately.'
    }
  },
  {
    slug: 'woluwe-saint-lambert',
    name: 'Woluwe-Saint-Lambert (1200)',
    postalCode: '1200',
    region: 'Brussels',
    responseTime: '25 - 30 min',
    landmarks: {
      fr: ['Georges Henri', 'Tomberg', 'Shopping Center', 'Roodebeek', 'Cliniques Saint-Luc'],
      nl: ['Georges Henrilaan', 'Tomberg', 'Shopping Center', 'Roodebeek', 'Sint-Lucaskliniek'],
      en: ['Georges Henri', 'Tomberg', 'Woluwe Shopping', 'Roodebeek', 'Saint-Luc Clinics']
    },
    clientAuthor: 'Bernard L.',
    clientNeighborhood: 'Georges Henri (1200)',
    clientService: { fr: 'Entretien Chaudière Gaz', nl: 'Onderhoud Gasketel', en: 'Gas Boiler Servicing' },
    clientReview: {
      fr: 'Entretien périodique obligatoire réalisé avec beaucoup de rigueur. Attestation PEB officielle transmise directement en PDF et version papier.',
      nl: 'Wettelijk periodiek onderhoud uiterst nauwkeurig uitgevoerd. Officieel EPB-attest meteen digitaal en op papier gekregen.',
      en: 'Mandatory periodic boiler servicing conducted thoroughly. Official EPB certificate provided immediately.'
    }
  },
  {
    slug: 'woluwe-saint-pierre',
    name: 'Woluwe-Saint-Pierre (1150)',
    postalCode: '1150',
    region: 'Brussels',
    responseTime: '25 - 30 min',
    landmarks: {
      fr: ['Montgomery', 'Parc de Woluwe', 'Avenue de Tervueren', 'Stockel', 'Chant d\'Oiseau'],
      nl: ['Montgomery', 'Woluwepark', 'Tervurenlaan', 'Stokkel', 'Vogelzang'],
      en: ['Montgomery', 'Woluwe Park', 'Tervueren Ave', 'Stockel', 'Birdsong Quarter']
    },
    clientAuthor: 'Sophie V.',
    clientNeighborhood: 'Stockel (1150)',
    clientService: { fr: 'Remplacement Chauffe-Eau', nl: 'Vervanging Boiler', en: 'Water Heater Replacement' },
    clientReview: {
      fr: 'Chauffe-eau électrique percé un samedi matin. Remplacé dans la journée par un ballon blindé économe. Excellente réactivité.',
      nl: 'Elektrische boiler lek op zaterdagochtend. Dezelfde dag nog vervangen door nieuw zuinig model. Geweldige reactiesnelheid.',
      en: 'Leaking electric water heater replaced within hours on a Saturday with high-efficiency tank. Excellent service.'
    }
  },

  // --- BRABANT FLAMAND & RAND (PROXIMITÉ SIÈGE API HEAT) ---
  {
    slug: 'halle',
    name: 'Halle / Hal (1500)',
    postalCode: '1500',
    region: 'Flanders',
    responseTime: '15 - 20 min',
    landmarks: {
      fr: ['Basilique Saint-Martin', 'Lembeek', 'Buizingen', 'Grand-Place', 'Canal'],
      nl: ['Sint-Martinusbasiliek', 'Lembeek', 'Buizingen', 'Grote Markt', 'Kanaal'],
      en: ['Saint-Martin Basilica', 'Lembeek', 'Buizingen', 'Main Market', 'Canal']
    },
    clientAuthor: 'Koen D.',
    clientNeighborhood: 'Lembeek (1500)',
    clientService: { fr: 'Installation Adoucisseur d\'Eau', nl: 'Plaatsing Waterontharder', en: 'Water Softener Installation' },
    clientReview: {
      fr: 'Eau extrêmement dure à Halle. Pose d\'un adoucisseur compact très efficace. Réduction immédiate du calcaire sur nos robinets.',
      nl: 'Zeer hard water in Halle. Compacte waterontharder vakkundig geïnstalleerd. Geen kalkaanslag meer op onze kranen.',
      en: 'High water hardness in Halle solved with a compact, ultra-efficient softener installation. No more limescale.'
    }
  },
  {
    slug: 'beersel',
    name: 'Beersel (1650)',
    postalCode: '1650',
    region: 'Flanders',
    responseTime: '15 - 20 min',
    landmarks: {
      fr: ['Château de Beersel', 'Alsemberg', 'Lot', 'Dworp', 'Huizingen'],
      nl: ['Kasteel van Beersel', 'Alsemberg', 'Lot', 'Dworp', 'Huizingen'],
      en: ['Beersel Castle', 'Alsemberg', 'Lot', 'Dworp', 'Huizingen Provincial Estate']
    },
    clientAuthor: 'Anja W.',
    clientNeighborhood: 'Alsemberg (1650)',
    clientService: { fr: 'Dépannage Plomberie 24/7', nl: 'Spoedherstelling Loodgieterij', en: '24/7 Emergency Plumbing' },
    clientReview: {
      fr: 'Robinet d\'arrêt général qui tournait dans le vide lors d\'une fuite. Dépannage express en 15 minutes chrono depuis Leeuw.',
      nl: 'Hoofdkraan dolgedraaid bij waterlek. API HEAT was er binnen 15 minuten vanuit Leeuw om de leiding af te sluiten en herstellen.',
      en: 'Main shutoff valve broke during pipe burst. API HEAT arrived in 15 minutes flat from Leeuw and resolved it safely.'
    }
  },
  {
    slug: 'dilbeek',
    name: 'Dilbeek (1700)',
    postalCode: '1700',
    region: 'Flanders',
    responseTime: '20 - 25 min',
    landmarks: {
      fr: ['Château de Viron', 'Groot-Bijgaarden', 'Itterbeek', 'Schepdaal', 'N8'],
      nl: ['Kasteel de Viron', 'Groot-Bijgaarden', 'Itterbeek', 'Schepdaal', 'N8'],
      en: ['Viron Castle', 'Groot-Bijgaarden', 'Itterbeek', 'Schepdaal', 'N8 Corridor']
    },
    clientAuthor: 'Pieter S.',
    clientNeighborhood: 'Groot-Bijgaarden (1700)',
    clientService: { fr: 'Entretien Chaudière Gaz', nl: 'Onderhoud Gasketel Vlaanderen', en: 'Gas Boiler Flemish Compliance' },
    clientReview: {
      fr: 'Entretien bisannuel effectué dans les règles de l\'art avec attestation de nettoyage et combustion officielle pour la Flandre.',
      nl: 'Tweejaarlijks ketelonderhoud keurig geregeld met officieel reinigings- en verbrandingsattest. Vriendelijke technieker.',
      en: 'Flemish biennial gas boiler servicing done thoroughly with official combustion certificates.'
    }
  },
  {
    slug: 'vilvoorde',
    name: 'Vilvoorde / Vilvorde (1800)',
    postalCode: '1800',
    region: 'Flanders',
    responseTime: '20 - 25 min',
    landmarks: {
      fr: ['Grote Markt', 'Kruitfabriek', 'Peutie', 'Houtem', 'Viaduc'],
      nl: ['Grote Markt', 'Kruitfabriek', 'Peutie', 'Houtem', 'Viaduct'],
      en: ['Grand Market', 'Kruitfabriek', 'Peutie', 'Houtem', 'Vilvoorde Viaduct']
    },
    clientAuthor: 'David N.',
    clientNeighborhood: 'Centrum (1800)',
    clientService: { fr: 'Débouchage WC & Égout', nl: 'Ontstoppen WC & Riolering', en: 'Toilet & Sewer Jetting' },
    clientReview: {
      fr: 'Refoulement d\'égout au rez-de-chaussée. Débouchage mécanique et passage caméra pour vérifier l\'état de la canalisation. Impeccable.',
      nl: 'Riool liep over op het gelijkvloers. Professioneel ontstopt en gecontroleerd met endoscopische camera.',
      en: 'Sewage backup resolved swiftly with mechanical snake and high-definition pipe inspection.'
    }
  },
  {
    slug: 'zaventem',
    name: 'Zaventem (1930)',
    postalCode: '1930',
    region: 'Flanders',
    responseTime: '20 - 25 min',
    landmarks: {
      fr: ['Aéroport International', 'Nossegem', 'Sint-Stevens-Woluwe', 'Sterrebeek', 'Corporate Village'],
      nl: ['Luchthaven Zaventem', 'Nossegem', 'Sint-Stevens-Woluwe', 'Sterrebeek', 'Corporate Village'],
      en: ['Brussels Airport', 'Nossegem', 'Sint-Stevens-Woluwe', 'Sterrebeek', 'Corporate Village']
    },
    clientAuthor: 'Tom H.',
    clientNeighborhood: 'Nossegem (1930)',
    clientService: { fr: 'Dépannage Chauffage Express', nl: 'Spoedherstelling Verwarming', en: 'Emergency Heating Repair' },
    clientReview: {
      fr: 'Panne de circulateur de chaudière en plein hiver. Technicien arrivé avec la pompe de rechange compatible. Chauffage rétabli aussitôt.',
      nl: 'Circulatiepomp defect tijdens vriesperiode. Technieker had juiste pomp meteen bij in zijn servicewagen. Binnen no-time warmte terug.',
      en: 'Circulator pump failure in winter. Technician carried the exact replacement on-board. Warmth restored immediately.'
    }
  },
  {
    slug: 'grimbergen',
    name: 'Grimbergen (1850)',
    postalCode: '1850',
    region: 'Flanders',
    responseTime: '20 - 25 min',
    landmarks: {
      fr: ['Abbaye de Grimbergen', 'Strombeek-Bever', 'Humbeek', 'Beigem', 'Mira'],
      nl: ['Abdij van Grimbergen', 'Strombeek-Bever', 'Humbeek', 'Beigem', 'Volkssterrenwacht Mira'],
      en: ['Grimbergen Abbey', 'Strombeek-Bever', 'Humbeek', 'Beigem', 'Mira Observatory']
    },
    clientAuthor: 'Lieve V.',
    clientNeighborhood: 'Strombeek (1850)',
    clientService: { fr: 'Réparation Fuite Radiateur', nl: 'Herstelling Radiatorlek', en: 'Radiator Leak Repair' },
    clientReview: {
      fr: 'Vanne thermostatique de radiateur qui fuyait sur le parquet. Remplacement rapide et purge complète du circuit de chauffage.',
      nl: 'Thermostatische radiatorkraan lekte op het parket. Snel vervangen en volledige cv-installatie ontlucht.',
      en: 'Thermostatic valve leaking onto wooden floor. Replaced swiftly with complete radiator bleeding.'
    }
  },
  {
    slug: 'wemmel',
    name: 'Wemmel (1780)',
    postalCode: '1780',
    region: 'Flanders',
    responseTime: '20 - 25 min',
    landmarks: {
      fr: ['Place Communale', 'Château de Wemmel', 'Bouchout', 'Ring Nord', 'Parc'],
      nl: ['Gemeenteplein', 'Kasteel van Wemmel', 'Bouchout', 'Noordring', 'Park'],
      en: ['Town Square', 'Wemmel Castle', 'Bouchout', 'North Ring', 'Town Park']
    },
    clientAuthor: 'Marc B.',
    clientNeighborhood: 'Bouchout (1780)',
    clientService: { fr: 'Débouchage Haute Pression', nl: 'Hogedrukontstopping', en: 'Hydro-Jetting Sewer' },
    clientReview: {
      fr: 'Canalisation extérieure bouchée par des racines. Curage haute pression très efficace sans dégrader le jardin.',
      nl: 'Buitenafvoer verstopt door wortelingroei. Zeer doeltreffend doorgespoten met hogedruk zonder tuin te beschadigen.',
      en: 'External drain blocked by roots. Cleared with high-pressure water jetting without damaging the landscaping.'
    }
  },
  {
    slug: 'leuven',
    name: 'Leuven / Louvain (3000)',
    postalCode: '3000',
    region: 'Flanders',
    responseTime: '25 - 30 min',
    landmarks: {
      fr: ['Hôtel de Ville', 'Grand Béguinage', 'Heverlee', 'Kessel-Lo', 'Oude Markt'],
      nl: ['Stadhuis Leuven', 'Groot Begijnhof', 'Heverlee', 'Kessel-Lo', 'Oude Markt'],
      en: ['City Hall', 'Grand Beguinage', 'Heverlee', 'Kessel-Lo', 'Old Market Square']
    },
    clientAuthor: 'Eline J.',
    clientNeighborhood: 'Heverlee (3001)',
    clientService: { fr: 'Chauffage & Boiler Étudiant', nl: 'CV & Boilerherstelling', en: 'Boiler & Heating Repair' },
    clientReview: {
      fr: 'Intervention d\'urgence dans notre maison de colocation pour une panne de chauffe-eau. Rapide, clair et très bon tarif.',
      nl: 'Dringende herstelling in ons studentenhuis voor boilerstoring. Heel snel, eerlijke prijs en vriendelijk.',
      en: 'Fast emergency repair for our shared student house water heater. Honest price and prompt service.'
    }
  },
  {
    slug: 'tervuren',
    name: 'Tervuren (3080)',
    postalCode: '3080',
    region: 'Flanders',
    responseTime: '25 - 30 min',
    landmarks: {
      fr: ['Musée de l\'Afrique', 'Parc de Tervuren', 'Moorsel', 'Duisburg', 'Vossem'],
      nl: ['Afrikamuseum', 'Warande van Tervuren', 'Moorsel', 'Duisburg', 'Vossem'],
      en: ['Africa Museum', 'Tervuren Park', 'Moorsel', 'Duisburg', 'Vossem']
    },
    clientAuthor: 'Gregory P.',
    clientNeighborhood: 'Moorsel (3080)',
    clientService: { fr: 'Entretien Pompe à Chaleur & Gaz', nl: 'Onderhoud Warmtepomp & Gas', en: 'Heat Pump & Gas Boiler' },
    clientReview: {
      fr: 'Contrôle complet de notre système hybride gaz et pompe à chaleur. Techniciens très compétents sur les technologies modernes.',
      nl: 'Grondige controle van onze hybride gasketel en warmtepomp. Uiterst bekwame technici.',
      en: 'Thorough inspection of our hybrid heating setup. Highly skilled technicians with modern HVAC gear.'
    }
  },
  {
    slug: 'overijse',
    name: 'Overijse (1900)',
    postalCode: '1900',
    region: 'Flanders',
    responseTime: '25 - 30 min',
    landmarks: {
      fr: ['Jezus-Eik', 'Druivenstreek', 'Tombeek', 'Maleizen', 'E411'],
      nl: ['Jezus-Eik', 'Druivenstreek', 'Tombeek', 'Maleizen', 'E411'],
      en: ['Jezus-Eik', 'Grape Region', 'Tombeek', 'Maleizen', 'E411 Highway']
    },
    clientAuthor: 'Patrick D.',
    clientNeighborhood: 'Jezus-Eik (1900)',
    clientService: { fr: 'Adoucisseur & Plomberie', nl: 'Waterontharder & Sanitair', en: 'Water Softener & Plumbing' },
    clientReview: {
      fr: 'Installation d\'un adoucisseur d\'eau pour protéger notre chaudière et robinetterie. Travail soigné et explications très claires.',
      nl: 'Plaatsing van waterontharder ter bescherming van onze cv-installatie. Proper afgewerkt en heldere uitleg.',
      en: 'Installed a water softener to protect our boiler. Clean plumbing work and clear operating instructions.'
    }
  },
  {
    slug: 'kraainem',
    name: 'Kraainem (1950)',
    postalCode: '1950',
    region: 'Flanders',
    responseTime: '20 - 25 min',
    landmarks: {
      fr: ['Reine Astrid', 'Baron d\'Huart', 'Château de Kraainem', 'Stockel frontière', 'Metro Kraainem'],
      nl: ['Koningin Astridlaan', 'Baron d\'Huartlaan', 'Kasteel van Kraainem', 'Grens Stokkel', 'Metro Kraainem'],
      en: ['Astrid Ave', 'Baron d\'Huart Ave', 'Kraainem Castle', 'Stockel border', 'Metro Kraainem']
    },
    clientAuthor: 'Nathalie B.',
    clientNeighborhood: 'Astrid (1950)',
    clientService: { fr: 'Dépannage Fuite Chasse d\'Eau', nl: 'Herstelling Toiletlekkage', en: 'Toilet Leak Repair' },
    clientReview: {
      fr: 'Chasse d\'eau encastrée Geberit qui coulait en continu. Dépannée en 45 minutes avec mécanisme d\'origine. Facture très raisonnable.',
      nl: 'Inbouwtoilet Geberit bleef doorlopen. Binnen 45 minuten hersteld met origineel binnenwerk.',
      en: 'Concealed Geberit toilet mechanism kept running. Fixed in 45 minutes with genuine parts.'
    }
  },
  {
    slug: 'hoeilaart',
    name: 'Hoeilaart (1560)',
    postalCode: '1560',
    region: 'Flanders',
    responseTime: '20 - 25 min',
    landmarks: {
      fr: ['Forêt de Soignes', 'Kasteel van Hoeilaart', 'Groenendaal', 'Gare', 'Serres'],
      nl: ['Zoniënwoud', 'Kasteel van Hoeilaart', 'Groenendaal', 'Station', 'Glazen Dorp'],
      en: ['Sonian Forest', 'Hoeilaart Castle', 'Groenendaal', 'Station', 'Greenhouses']
    },
    clientAuthor: 'Bart M.',
    clientNeighborhood: 'Groenendaal (1560)',
    clientService: { fr: 'Entretien Chaudière Mazout & Gaz', nl: 'Onderhoud Stookolie & Gas', en: 'Oil & Gas Boiler Service' },
    clientReview: {
      fr: 'Entretien annuel de notre chaudière mazout avec ramonage de la cheminée. Technicien ponctuel et certificat remis immédiatement.',
      nl: 'Jaarlijks onderhoud van mazoutketel inclusief schoorsteenvegen. Stipt op tijd en attest direct bezorgd.',
      en: 'Annual oil boiler service including chimney sweeping. Prompt arrival and immediate compliance certificates.'
    }
  },
  {
    slug: 'asse',
    name: 'Asse (1730)',
    postalCode: '1730',
    region: 'Flanders',
    responseTime: '25 - 30 min',
    landmarks: {
      fr: ['Zellik', 'Mollem', 'Kobbegem', 'Bekkerzeel', 'N9'],
      nl: ['Zellik', 'Mollem', 'Kobbegem', 'Bekkerzeel', 'N9'],
      en: ['Zellik', 'Mollem', 'Kobbegem', 'Bekkerzeel', 'N9 Corridor']
    },
    clientAuthor: 'Johan K.',
    clientNeighborhood: 'Zellik (1731)',
    clientService: { fr: 'Débouchage Évier & Cuisine', nl: 'Ontstoppen Gootsteen Keuken', en: 'Kitchen Sink Unblocking' },
    clientReview: {
      fr: 'Évier de cuisine totalement bouché par les graisses. Débouchage mécanique au furet électrique. Écoulement comme neuf.',
      nl: 'Keukenafvoerpot verstopt door vetresten. Doeltreffend gereinigd met elektrische veer.',
      en: 'Kitchen sink drain blocked by grease buildup. Cleared with motorized snake in no time.'
    }
  },

  // --- GRANDES MÉTROPOLES FLAMANDES ---
  {
    slug: 'antwerpen',
    name: 'Antwerpen / Anvers (2000)',
    postalCode: '2000',
    region: 'Flanders',
    responseTime: '30 - 35 min',
    landmarks: {
      fr: ['Grote Markt', 'Port d\'Anvers', 'Meir', 'Het Zuid', 'Berchem', 'Deurne'],
      nl: ['Grote Markt', 'Haven van Antwerpen', 'Meir', 'Het Zuid', 'Berchem', 'Deurne'],
      en: ['Grand Market', 'Antwerp Port', 'Meir Shopping', 'South Quarter', 'Berchem', 'Deurne']
    },
    clientAuthor: 'Filip D.',
    clientNeighborhood: 'Het Zuid (2000)',
    clientService: { fr: 'Dépannage Chaudière Condensation', nl: 'Herstelling Condensatieketel', en: 'Condensing Boiler Repair' },
    clientReview: {
      fr: 'Chaudière Vaillant en code erreur F28 à Anvers. Dépannage rapide le soir même, allumeur et électrode changés. Parfait.',
      nl: 'Foutcode F28 op Vaillant ketel in Antwerpen. Dezelfde avond nog geholpen en ontstekingselektrode vervangen. Topservice.',
      en: 'Error code F28 on Vaillant boiler resolved quickly the same evening in Antwerp. Highly recommended.'
    }
  },
  {
    slug: 'mechelen',
    name: 'Mechelen / Malines (2800)',
    postalCode: '2800',
    region: 'Flanders',
    responseTime: '25 - 30 min',
    landmarks: {
      fr: ['Tour Saint-Rombaut', 'IJzerenleen', 'Nekkerspoel', 'Battel', 'Dijle'],
      nl: ['Sint-Romboutstoren', 'IJzerenleen', 'Nekkerspoel', 'Battel', 'Dijle'],
      en: ['St. Rumbold Tower', 'IJzerenleen', 'Nekkerspoel', 'Battel', 'River Dijle']
    },
    clientAuthor: 'Katrien B.',
    clientNeighborhood: 'Centrum (2800)',
    clientService: { fr: 'Recherche de Fuite d\'Eau', nl: 'Lekdetectie Zonder Breken', en: 'Acoustic Leak Detection' },
    clientReview: {
      fr: 'Goutte à goutte invisible sous la douche. Fuite localisée précisément grâce au gaz traceur. Réparation ciblée sans tout casser.',
      nl: 'Onzichtbaar lek onder inloopdouche opgespoord met akoestische sensor. Doelgerichte herstelling.',
      en: 'Concealed leak under shower tray accurately detected via acoustic sensors and fixed cleanly.'
    }
  },
  {
    slug: 'gent',
    name: 'Gent / Gand (9000)',
    postalCode: '9000',
    region: 'Flanders',
    responseTime: '30 - 35 min',
    landmarks: {
      fr: ['Graslei & Korenlei', 'Château des Comtes', 'Sint-Pieters', 'Ledeberg', 'Wondelgem'],
      nl: ['Graslei & Korenlei', 'Gravensteen', 'Sint-Pieters', 'Ledeberg', 'Wondelgem'],
      en: ['Graslei', 'Castle of Counts', 'Sint-Pieters', 'Ledeberg', 'Wondelgem']
    },
    clientAuthor: 'Stijn V.',
    clientNeighborhood: 'Sint-Amandsberg (9040)',
    clientService: { fr: 'Entretien Chaudière Gaz', nl: 'Onderhoud Gasketel Gent', en: 'Gas Boiler Service Ghent' },
    clientReview: {
      fr: 'Technicien ponctuel, méticuleux pour l\'entretien de notre chaudière Bulex. Mesures de combustion impeccables et attestation fournie.',
      nl: 'Punctuele monteur voor onderhoud van Bulex ketel in Gent. Perfecte rookgasmeting en attest digitaal ontvangen.',
      en: 'Punctual and meticulous service on our Bulex boiler in Ghent with full combustion analysis.'
    }
  },
  {
    slug: 'aalst',
    name: 'Aalst / Alost (9300)',
    postalCode: '9300',
    region: 'Flanders',
    responseTime: '25 - 30 min',
    landmarks: {
      fr: ['Grote Markt', 'Beffroi', 'Erembodegem', 'Nieuwerkerken', 'Dendre'],
      nl: ['Grote Markt', 'Belfort', 'Erembodegem', 'Nieuwerkerken', 'Dender'],
      en: ['Main Market', 'Belfry', 'Erembodegem', 'Nieuwerkerken', 'Dender River']
    },
    clientAuthor: 'Gert M.',
    clientNeighborhood: 'Erembodegem (9320)',
    clientService: { fr: 'Débouchage Canalisation', nl: 'Ontstopping Riolering', en: 'Sewer Jetting' },
    clientReview: {
      fr: 'WC bouché et débordement dans la buanderie. Arrivée rapide et débouchage haute pression très efficace.',
      nl: 'Verstopte toiletpot en overlopende afvoer. Snel geholpen met hogedrukslang.',
      en: 'Blocked toilet and overflowing laundry line cleared efficiently with high pressure jetting.'
    }
  },
  {
    slug: 'sint-niklaas',
    name: 'Sint-Niklaas (9100)',
    postalCode: '9100',
    region: 'Flanders',
    responseTime: '30 - 35 min',
    landmarks: {
      fr: ['Plus Grande Place de Belgique', 'Waasland Shopping', 'Belsele', 'Sinaai', 'Nieuwkerken'],
      nl: ['Grootste Marktplein', 'Waasland Shopping', 'Belsele', 'Sinaai', 'Nieuwkerken'],
      en: ['Largest Market Square', 'Waasland Shopping', 'Belsele', 'Sinaai', 'Nieuwkerken']
    },
    clientAuthor: 'Hilde C.',
    clientNeighborhood: 'Belsele (9111)',
    clientService: { fr: 'Installation Adoucisseur d\'Eau', nl: 'Plaatsing Waterontharder Waasland', en: 'Water Softener Waasland' },
    clientReview: {
      fr: 'Dans le Pays de Waes l\'eau est très calcaire. Pose impeccable d\'un adoucisseur qui a transformé la douceur de l\'eau.',
      nl: 'In het Waasland is het leidingwater hard. Onze nieuwe ontkalker werkt fantastisch.',
      en: 'Installed an effective water softener in the Waasland area. Great improvement in water quality.'
    }
  },
  {
    slug: 'brugge',
    name: 'Brugge / Bruges (8000)',
    postalCode: '8000',
    region: 'Flanders',
    responseTime: '35 - 40 min',
    landmarks: {
      fr: ['Markt & Beffroi', 'Minnewater', 'Assebroek', 'Sint-Michiels', 'Sint-Kruis'],
      nl: ['Markt & Belfort', 'Minnewater', 'Assebroek', 'Sint-Michiels', 'Sint-Kruis'],
      en: ['Market & Belfry', 'Lake of Love', 'Assebroek', 'Sint-Michiels', 'Sint-Kruis']
    },
    clientAuthor: 'Jan D.',
    clientNeighborhood: 'Sint-Kruis (8310)',
    clientService: { fr: 'Dépannage Fuite Sanitaire', nl: 'Spoedherstelling Sanitair', en: 'Sanitary Leak Repair' },
    clientReview: {
      fr: 'Grosse fuite d\'eau sous évier un samedi après-midi. Plombier très sérieux et travail soigné.',
      nl: 'Zware waterlek onder gootsteen op zaterdag. Heel betrouwbare en propere loodgieter.',
      en: 'Major pipe leak under kitchen sink on a Saturday fixed cleanly and reliably.'
    }
  },
  {
    slug: 'kortrijk',
    name: 'Kortrijk / Courtrai (8500)',
    postalCode: '8500',
    region: 'Flanders',
    responseTime: '35 - 40 min',
    landmarks: {
      fr: ['Tours du Broel', 'Grote Markt', 'Heule', 'Bissegem', 'Lys'],
      nl: ['Broeltorens', 'Grote Markt', 'Heule', 'Bissegem', 'Leie'],
      en: ['Broel Towers', 'Main Square', 'Heule', 'Bissegem', 'River Lys']
    },
    clientAuthor: 'Luc T.',
    clientNeighborhood: 'Heule (8501)',
    clientService: { fr: 'Entretien Chaudière Gaz', nl: 'Onderhoud Gasketel Kortrijk', en: 'Gas Boiler Service Kortrijk' },
    clientReview: {
      fr: 'Entretien chaudière Viessmann avec réglage de combustion précis. Très bon service technique.',
      nl: 'Onderhoud Viessmann gasketel met perfecte afstelling van de brander. Uitstekende service.',
      en: 'Precision burner calibration and servicing on Viessmann boiler. Excellent technician.'
    }
  },
  {
    slug: 'roeselare',
    name: 'Roeselare / Roulers (8800)',
    postalCode: '8800',
    region: 'Flanders',
    responseTime: '35 - 40 min',
    landmarks: {
      fr: ['Château de Rumbeke', 'Grote Markt', 'Beveren', 'Oekene', 'Roulers Gare'],
      nl: ['Kasteel van Rumbeke', 'Grote Markt', 'Beveren', 'Oekene', 'Station Roeselare'],
      en: ['Rumbeke Castle', 'Grand Market', 'Beveren', 'Oekene', 'Station']
    },
    clientAuthor: 'Geert V.',
    clientNeighborhood: 'Rumbeke (8800)',
    clientService: { fr: 'Débouchage Sanitaire Express', nl: 'Snelle Ontstopping Afvoer', en: 'Express Drain Unblocking' },
    clientReview: {
      fr: 'Évacuation de salle de bain complètement engorgée. Débouchage rapide au furet mécanique.',
      nl: 'Badkamerafvoer zat muurvast. Zeer vlot verholpen met elektrische ontstoppingsveer.',
      en: 'Bathroom main line completely backed up. Cleared quickly with mechanical snake.'
    }
  },
  {
    slug: 'hasselt',
    name: 'Hasselt (3500)',
    postalCode: '3500',
    region: 'Flanders',
    responseTime: '35 - 40 min',
    landmarks: {
      fr: ['Grand Ring', 'Jardin Japonais', 'Kuringen', 'Corda Campus', 'Grote Markt'],
      nl: ['Grote Ring', 'Japanse Tuin', 'Kuringen', 'Corda Campus', 'Grote Markt'],
      en: ['Grand Ring', 'Japanese Garden', 'Kuringen', 'Corda Campus', 'Market Square']
    },
    clientAuthor: 'Wouter P.',
    clientNeighborhood: 'Kuringen (3511)',
    clientService: { fr: 'Dépannage Chauffe-Eau Électrique', nl: 'Herstelling Elektrische Boiler', en: 'Electric Water Heater Repair' },
    clientReview: {
      fr: 'Résistance stéatite grillée sur notre chauffe-eau. Remplacée le jour même sans vidange intégrale.',
      nl: 'Verwarmingselement doorgebrand in boiler. Dezelfde dag vakkundig vervangen.',
      en: 'Steatite heating element burnt out in water heater. Replaced on the same day cleanly.'
    }
  },
  {
    slug: 'genk',
    name: 'Genk (3600)',
    postalCode: '3600',
    region: 'Flanders',
    responseTime: '35 - 40 min',
    landmarks: {
      fr: ['C-Mine', 'Bokrijk', 'Waterschei', 'Winterslag', 'Thor Park'],
      nl: ['C-Mine', 'Bokrijk', 'Waterschei', 'Winterslag', 'Thor Park'],
      en: ['C-Mine', 'Bokrijk', 'Waterschei', 'Winterslag', 'Thor Park']
    },
    clientAuthor: 'Mustafa Y.',
    clientNeighborhood: 'Winterslag (3600)',
    clientService: { fr: 'Entretien & Dépannage Chauffage', nl: 'Onderhoud & Depannage Verwarming', en: 'Boiler Repair & Tune-up' },
    clientReview: {
      fr: 'Chaudière au gaz en panne de pression. Vase d\'expansion regonflé et fuite de soupape colmatée.',
      nl: 'Drukverlies op gasketel. Expansievat bijgevuld en overdrukventiel hersteld.',
      en: 'Boiler pressure loss solved with expansion vessel refill and valve replacement.'
    }
  },

  // --- WALLONIE & BRABANT WALLON ---
  {
    slug: 'braine-lalleud',
    name: 'Braine-l\'Alleud (1420)',
    postalCode: '1420',
    region: 'Wallonia',
    responseTime: '20 - 25 min',
    landmarks: {
      fr: ['Lion de Waterloo', 'Ophain-Bois-Seigneur-Isaac', 'Lillois-Witterzée', 'Gare', 'Hôpital'],
      nl: ['Leeuw van Waterloo', 'Ophain-Bois-Seigneur-Isaac', 'Lillois-Witterzée', 'Station', 'Ziekenhuis'],
      en: ['Waterloo Lion Butte', 'Ophain', 'Lillois', 'Train Station', 'Hospital Quarter']
    },
    clientAuthor: 'Thierry G.',
    clientNeighborhood: 'Lillois (1428)',
    clientService: { fr: 'Dépannage Chaudière Mazout', nl: 'Herstelling Stookolieketel', en: 'Oil Boiler Troubleshooting' },
    clientReview: {
      fr: 'Gicleur mazout encrassé et brûleur en sécurité. Dépannage rapide en 25 min avec réglage de combustion parfait.',
      nl: 'Verstopte stookoliesproeier en ketel in beveiliging. Binnen 25 min geholpen met perfecte verbrandingsafstelling.',
      en: 'Clogged oil nozzle and safety lockout. Fixed in 25 min with precise combustion tuning.'
    }
  },
  {
    slug: 'wavre',
    name: 'Wavre / Waver (1300)',
    postalCode: '1300',
    region: 'Wallonia',
    responseTime: '25 - 30 min',
    landmarks: {
      fr: ['Place Bosch', 'Limal', 'Bierges', 'Walibi', 'Zone Industrielle Nord'],
      nl: ['Boschplein', 'Limal', 'Bierges', 'Walibi', 'Industriezone Noord'],
      en: ['Bosch Square', 'Limal', 'Bierges', 'Walibi', 'North Industrial Park']
    },
    clientAuthor: 'Sandrine F.',
    clientNeighborhood: 'Bierges (1301)',
    clientService: { fr: 'Entretien Légal Gaz Wallonie (SPW)', nl: 'Wettelijk Gasketelonderhoud Wallonië', en: 'Walloon SPW Boiler Compliance' },
    clientReview: {
      fr: 'Entretien bisannuel effectué avec soin. Attestation officielle SPW Région Wallonne délivrée directement.',
      nl: 'Tweejaarlijks ketelonderhoud keurig geregeld met officieel Waals SPW-attest.',
      en: 'Biennial gas boiler maintenance completed with official SPW Walloon certification.'
    }
  },
  {
    slug: 'liege',
    name: 'Liège / Luik (4000)',
    postalCode: '4000',
    region: 'Wallonia',
    responseTime: '30 - 35 min',
    landmarks: {
      fr: ['Place Saint-Lambert', 'Guillemins', 'Outremeuse', 'Belle-Île', 'Sart-Tilman', 'Rocourt'],
      nl: ['Sint-Lambertusplein', 'Guillemins', 'Outremeuse', 'Belle-Île', 'Sart-Tilman', 'Rocourt'],
      en: ['Saint-Lambert Square', 'Guillemins Station', 'Outremeuse', 'Belle-Ile', 'Sart-Tilman', 'Rocourt']
    },
    clientAuthor: 'Nicolas D.',
    clientNeighborhood: 'Guillemins (4000)',
    clientService: { fr: 'Débouchage Urgent Colonne', nl: 'Spoedontstopping Afvoerkolom', en: 'Vertical Stack Drain Jetting' },
    clientReview: {
      fr: 'Colonne d\'évacuation de l\'immeuble bouchée un dimanche. Intervention rapide et curage sous haute pression sans bavure.',
      nl: 'Verstopte standleiding in appartementsgebouw op zondag. Vlug ter plaatse en vakkundig gereinigd.',
      en: 'Apartment vertical stack clogged on a Sunday. Prompt arrival and high-pressure jetting solved it cleanly.'
    }
  },
  {
    slug: 'charleroi',
    name: 'Charleroi (6000)',
    postalCode: '6000',
    region: 'Wallonia',
    responseTime: '30 - 35 min',
    landmarks: {
      fr: ['Place de la Digue', 'Rive Gauche', 'Gosselies', 'Jumet', 'Mont-sur-Marchienne', 'Marcinelle'],
      nl: ['Digueplein', 'Rive Gauche', 'Gosselies', 'Jumet', 'Mont-sur-Marchienne', 'Marcinelle'],
      en: ['Digue Square', 'Rive Gauche Shopping', 'Gosselies', 'Jumet', 'Marcinelle']
    },
    clientAuthor: 'Cédric B.',
    clientNeighborhood: 'Gosselies (6041)',
    clientService: { fr: 'Dépannage Chaudière Gaz', nl: 'Depannage Gasketel', en: 'Gas Boiler Repair' },
    clientReview: {
      fr: 'Plus de chauffage ni d\'eau chaude avec un bébé à la maison. Chauffagiste arrivé en 30 minutes, sonde remplacée immédiatement.',
      nl: 'Geen verwarming en warm water met baby in huis. Binnen 30 min technieker ter plaatse en sensor vervangen.',
      en: 'No heat or hot water with an infant at home. Technician arrived in 30 minutes and replaced sensor immediately.'
    }
  },
  {
    slug: 'namur',
    name: 'Namur / Namen (5000)',
    postalCode: '5000',
    region: 'Wallonia',
    responseTime: '30 - 35 min',
    landmarks: {
      fr: ['Citadelle de Namur', 'Jambes', 'Salzinnes', 'Bouge', 'Confluent Sambre et Meuse'],
      nl: ['Citadel van Namen', 'Jambes', 'Salzinnes', 'Bouge', 'Samenvloeiing Samber en Maas'],
      en: ['Namur Citadel', 'Jambes', 'Salzinnes', 'Bouge', 'Sambre & Meuse Confluence']
    },
    clientAuthor: 'Véronique P.',
    clientNeighborhood: 'Jambes (5100)',
    clientService: { fr: 'Recherche de Fuite & Tuyauterie', nl: 'Lekdetectie & Leidingherstelling', en: 'Leak Detection & Pipe Repair' },
    clientReview: {
      fr: 'Chute de pression constante sur le manomètre de la chaudière. Micro-fuite détectée sous chape et réparée sans démolition.',
      nl: 'Constante drukval op ketelmeter. Onzichtbaar lekje in de vloer opgespoord en vakkundig verholpen.',
      en: 'Constant boiler pressure drop. Micro-leak located in subfloor and repaired without demolition.'
    }
  },
  {
    slug: 'mons',
    name: 'Mons / Bergen (7000)',
    postalCode: '7000',
    region: 'Wallonia',
    responseTime: '30 - 35 min',
    landmarks: {
      fr: ['Grand-Place', 'Beffroi de Mons', 'Nimy', 'Cuesmes', 'Ghlin', 'Grands Prés'],
      nl: ['Grote Markt', 'Belfort van Bergen', 'Nimy', 'Cuesmes', 'Ghlin', 'Grands Prés'],
      en: ['Grand Square', 'Mons Belfry', 'Nimy', 'Cuesmes', 'Ghlin', 'Grands Pres']
    },
    clientAuthor: 'Aurélien L.',
    clientNeighborhood: 'Nimy (7020)',
    clientService: { fr: 'Débouchage Chambre de Visite', nl: 'Ontstopping Toezichtsput', en: 'Inspection Chamber Unblocking' },
    clientReview: {
      fr: 'Chambre de visite extérieure débordante. Curage hydrocureuse haute pression et nettoyage complet. Très satisfait.',
      nl: 'Overlopende toezichtsput buiten. Krachtig doorgespoten met hogedrukwagen.',
      en: 'Exterior inspection pit overflowing. Power-jetted and cleared thoroughly.'
    }
  },
  {
    slug: 'la-louviere',
    name: 'La Louvière (7100)',
    postalCode: '7100',
    region: 'Wallonia',
    responseTime: '30 - 35 min',
    landmarks: {
      fr: ['Place Maugrétout', 'Haine-Saint-Paul', 'Strépy-Bracquegnies', 'Ascenseur à Bateaux', 'Tivoli'],
      nl: ['Maugrétoutplein', 'Haine-Saint-Paul', 'Strépy-Bracquegnies', 'Scheepslift', 'Tivoli'],
      en: ['Maugretout Square', 'Haine-Saint-Paul', 'Strepy-Bracquegnies', 'Boat Lift', 'Tivoli']
    },
    clientAuthor: 'Fabienne R.',
    clientNeighborhood: 'Strépy (7110)',
    clientService: { fr: 'Entretien Chaudière & Ramonage', nl: 'Ketelonderhoud & Schoorsteen', en: 'Boiler & Chimney Cleaning' },
    clientReview: {
      fr: 'Entretien annuel chaudière et ramonage conduit de cheminée. Travail impeccable, propre et rapport officiel remis.',
      nl: 'Jaarlijks ketelonderhoud en schouwvegen. Heel proper gewerkt en officieel verslag gekregen.',
      en: 'Annual boiler maintenance and chimney sweep. Clean job and official compliance report issued.'
    }
  }
];

export function generateExtendedCities(): CityData[] {
  return RAW_COMMUNES.map((raw) => {
    const regionLabel = {
      Brussels: {
        fr: 'Région de Bruxelles-Capitale',
        nl: 'Brussels Hoofdstedelijk Gewest',
        en: 'Brussels-Capital Region'
      },
      Flanders: {
        fr: 'Région Flamande (Vlaanderen)',
        nl: 'Vlaams Gewest',
        en: 'Flemish Region'
      },
      Wallonia: {
        fr: 'Région Wallonne (Wallonie)',
        nl: 'Waals Gewest',
        en: 'Walloon Region'
      }
    }[raw.region];

    const isFlanders = raw.region === 'Flanders';
    const isBrussels = raw.region === 'Brussels';
    const certText = isBrussels
      ? 'Habilitation Bruxelles Environnement (G1/G2, PEB)'
      : isFlanders
      ? 'Erkenning Vlaamse Overheid (Reinigingsattest)'
      : 'Agrément Région Wallonne (SPW Gaz & Mazout)';

    return {
      slug: raw.slug,
      name: raw.name,
      postalCode: raw.postalCode,
      region: raw.region,
      regionLabel,
      responseTime: raw.responseTime,
      landmarks: raw.landmarks,
      headline: {
        fr: `Plombier, Chauffagiste & Débouchage 24/7 à ${raw.name}`,
        nl: `Loodgieter, Verwarmingsmonteur & Ontstoppingsdienst 24/7 in ${raw.name}`,
        en: `Emergency Plumber, Heating & Drain Jetting 24/7 in ${raw.name}`
      },
      description: {
        fr: `Dépannage d'urgence 24h/24 et 7j/7 à ${raw.name}. Recherche de fuite d'eau non destructive, entretien et dépannage chaudière gaz/mazout, débouchage canalisations haute pression et adoucisseurs d'eau.`,
        nl: `Spoeddienst 24/7 in ${raw.name}. Lekdetectie zonder breekwerk, herstelling en onderhoud van gas- en stookolieketels, hogedrukontstopping en waterontharders.`,
        en: `24/7 emergency repair in ${raw.name}. Non-destructive leak detection, gas/oil boiler servicing, high-pressure drain jetting, and water softeners.`
      },
      localIntro: {
        fr: `Nos techniciens circulent en permanence dans le secteur de ${raw.name} (${raw.landmarks.fr.slice(0, 3).join(', ')}) avec des véhicules d'outillage complets pour intervenir chez vous en ${raw.responseTime}.`,
        nl: `Onze mobiele servicewagens zijn permanent onderweg in ${raw.name} (${raw.landmarks.nl.slice(0, 3).join(', ')}) voor snelle depannage binnen ${raw.responseTime}.`,
        en: `Our mobile technicians continuously patrol ${raw.name} (${raw.landmarks.en.slice(0, 3).join(', ')}) with fully equipped vans for arrival in ${raw.responseTime}.`
      },
      specialties: {
        fr: [
          `Arrivée express garantie en ${raw.responseTime} à ${raw.name}`,
          `Entretien légal certifié avec attestation officielle (${certText})`,
          'Débouchage express haute pression (WC, éviers, colonnes d\'évacuation)',
          'Recherche de fuite d\'eau non destructive par caméra thermique & gaz traceur'
        ],
        nl: [
          `Gegarandeerde snelle aankomst binnen ${raw.responseTime} in ${raw.name}`,
          `Wettelijk gecertificeerd ketelonderhoud met officieel attest (${certText})`,
          'Hogedrukontstopping van toiletten, afvoeren en rioleringen',
          'Niet-destructieve lekdetectie met thermografie en traceergas'
        ],
        en: [
          `Guaranteed rapid response in ${raw.responseTime} across ${raw.name}`,
          `Official certified boiler inspection and certificate (${certText})`,
          'Express hydro-jetting unblocking for toilets, sinks, and mains',
          'Non-destructive leak detection via thermal imaging and acoustic sensors'
        ]
      },
      faqs: [
        {
          question: {
            fr: `Quel est votre délai d'intervention réel à ${raw.name} ?`,
            nl: `Wat is jullie effectieve responstijd in ${raw.name}?`,
            en: `What is your actual response time in ${raw.name}?`
          },
          answer: {
            fr: `Grâce à notre dispatching mobile permanent, un dépanneur qualifié arrive chez vous en ${raw.responseTime} à ${raw.name}.`,
            nl: `Dankzij onze permanente mobiele vloot arriveert een erkend technicus binnen ${raw.responseTime} in ${raw.name}.`,
            en: `Thanks to our roaming service fleet, our certified technician reaches your home in ${raw.responseTime} in ${raw.name}.`
          }
        },
        {
          question: {
            fr: `Délivrez-vous l'attestation de contrôle officielle pour les chaudières à ${raw.name} ?`,
            nl: `Leveren jullie het officiële keuringsattest af voor ketels in ${raw.name}?`,
            en: `Do you deliver the official boiler inspection certificate in ${raw.name}?`
          },
          answer: {
            fr: `Absolument. Nos techniciens habilités remettent immédiatement l'attestation légale de contrôle périodique et de combustion exigée par les réglementations en vigueur.`,
            nl: `Zeker. Onze erkende technici leveren direct het officiële reinigings- en verbrandingsattest af dat voldoet aan alle gewestelijke voorschriften.`,
            en: `Yes. Our licensed engineers provide the official combustion and maintenance compliance certificate on-site.`
          }
        }
      ],
      testimonial: {
        author: raw.clientAuthor,
        neighborhood: raw.clientNeighborhood,
        text: raw.clientReview,
        rating: 5,
        service: raw.clientService
      }
    };
  });
}
